import * as React from 'react';
import { InlineText3 } from '@cian/ui-kit';
import { IconProductTrust16 } from '@cian/ui-kit-design-tokens/icons';
import * as styles from './NewBuildingCardListed.css';

interface INewBuildingCardListedProps {
  images: React.ReactNode[];
  title: React.ReactNode;
  isReliable: boolean;
  finishLabel: React.ReactNode;
  subwayInfo: React.ReactNode;
  address: React.ReactNode;
  apartments: React.ReactNode;
  detailsButton: React.ReactNode;
  seeAll: React.ReactNode;
  morePhotoUrl?: string;
}

export function NewBuildingCardListed({
  images,
  title,
  isReliable,
  finishLabel,
  subwayInfo,
  address,
  apartments,
  detailsButton,
  seeAll,
  morePhotoUrl,
}: INewBuildingCardListedProps) {
  return (
    <article className={styles['card']}>
      <div className={styles['media']}>
        <ul className={styles['image-list']}>
          {React.Children.map(images, (item, index) => (
            <li key={index} className={styles['image-item']}>
              {item}

              {morePhotoUrl && index === images.length - 1 && (
                <a href={morePhotoUrl} target="_blank" rel="noopener noreferrer" className={styles['image-more']}>
                  <InlineText3 color="text-inverted-default">Еще фото</InlineText3>
                </a>
              )}
            </li>
          ))}
        </ul>
      </div>

      <div>
        <div className={styles['title']}>
          {title}

          {isReliable && (
            <span className={styles['reliable']}>
              <IconProductTrust16 color="icon-main-default" />
            </span>
          )}
        </div>

        <div className={styles['finish']}>{finishLabel}</div>
        <div className={styles['subway']}>{subwayInfo}</div>
        {address}

        {apartments && <div className={styles['apartments']}>{apartments}</div>}

        <div className={styles['info-buttons']}>
          <div className={styles['details']}>{detailsButton}</div>

          {seeAll}
        </div>
      </div>
    </article>
  );
}
